import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const referentLocaleModule: LocaleModule = {
  name: "referent",
  messages: { en: en, it: it },
};
